var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "marketing-consent-confirmation-page" }, [
    _c("div", { staticClass: "marketing-consent-confirmation-page__header" }, [
      _c(
        "div",
        { staticClass: "marketing-consent-confirmation-page__header-logo" },
        [_c("CompassLogo", { attrs: { type: "logo", width: 160 } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "marketing-consent-confirmation-page__content" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "marketing-consent-confirmation-page__content-title typographies-display-large"
        },
        [_vm._v("\n            " + _vm._s(_vm.labels.title) + "\n        ")]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "marketing-consent-confirmation-page__content-information typographies-paragraph-x-large-regular"
        },
        [
          _vm._v(
            "\n            " + _vm._s(_vm.labels.information) + "\n        "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "marketing-consent-confirmation-page__content-buttons" },
        [
          _c("CompassButton", {
            attrs: { label: _vm.labels.button, size: "large" },
            on: {
              click: function($event) {
                return _vm.goToUrl(_vm.updateCustomerPreferenceUrl)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "marketing-consent-confirmation-page__content-help typographies-paragraph-medium-semibold"
        },
        [
          _vm._v(
            "\n            " + _vm._s(_vm.labels.help.text) + "\n            "
          ),
          _c("CompassLink", {
            attrs: { label: _vm.labels.help.link, link: "javascript:;" },
            on: { click: _vm.openIntercom }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "marketing-consent-confirmation-page__content-illustration"
      },
      [
        _c("img", {
          attrs: {
            src: "/ressources/logged/img/illustrations/confirmation.svg"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }